import { render, staticRenderFns } from "./addYfparams.vue?vue&type=template&id=061760fb&"
import script from "./addYfparams.vue?vue&type=script&lang=js&"
export * from "./addYfparams.vue?vue&type=script&lang=js&"
import style0 from "./addYfparams.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('061760fb')) {
      api.createRecord('061760fb', component.options)
    } else {
      api.reload('061760fb', component.options)
    }
    module.hot.accept("./addYfparams.vue?vue&type=template&id=061760fb&", function () {
      api.rerender('061760fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/components/addYfparams.vue"
export default component.exports